var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "socket-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.tabName,
            callback: function ($$v) {
              _vm.tabName = $$v
            },
            expression: "tabName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "回傳全紀錄", name: "positionLogs" } },
            [
              _c(
                "div",
                { staticStyle: { height: "100%" } },
                [_c("position-log")],
                1
              ),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "旅遊團紀錄", name: "travelLogs" } },
            [
              _c(
                "div",
                { staticStyle: { height: "100%" } },
                [_c("position-travel-log")],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }